module.exports = __webpack_public_path__ + "static/media/gmr_air_active.264c9d49.svg";